module.exports = ".company-type {\n    margin: 10px -15px;\n    border-top: 1px solid #ccc;\n    border-bottom: 1px solid #ccc;\n    padding: 10px 0;\n}\n\n.company-type .tip {\n    padding: 0px 5px;\n    background: #ddd;\n    border-radius: 50%;\n    border: 1px solid #ccc;\n    font-weight: bold;\n}\n\n.company-selector-resize {\n    height: 38px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/companie-create/companie-create.component.css
// module id = ./src/app/views/companies/companie-create/companie-create.component.css
// module chunks = main